<template>
    <div class="d-flex pl-4">
        <div class="d-flex justify-center align-center mr-2">
            <small>Showing </small>
            <small>&nbsp {{showingOf}} of &nbsp;</small>
            <div v-if="!itemsLoading">
                <v-tooltip bottom v-if="!total">
                    <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on" @click="getTotalCount">more_horiz</v-icon>
                    </template>
                    <span>Total count</span>
                </v-tooltip>
                <small v-else>{{total}}</small>
            </div>
            <div v-else>
                <div class="pulse-container">
                    <div class="pulse-bubble pulse-bubble-1"></div>
                    <div class="pulse-bubble pulse-bubble-2"></div>
                    <div class="pulse-bubble pulse-bubble-3"></div>
                </div>
            </div>
        </div>
        <v-spacer/>
        <div class="d-flex justify-center align-center mr-2">
            <small class="mr-4">
                Rows per page
            </small>
            <v-select :items="page_options" style="width: 70px" v-model="rowsPerPage" hide-details class="mb-2"
                      @change="handleRowChange"/>

        </div>

        <v-icon @click="prev" :disabled="disablePrev">
            mdi-chevron-left
        </v-icon>
        <v-icon @click="next" :disabled="disableNext" class="mr-3">
            mdi-chevron-right
        </v-icon>
    </div>
</template>

<script>
    export default {
        name: "IssuedVisaFooter",
        props: ['disablePrev', 'disableNext', 'perPage', 'total', 'itemsLoading', 'showingOf'],
        data() {
            return {
                page_options: [25,50,100,200,300,500,1000],
                rowsPerPage: 25
            }
        },
        methods: {
            next() {
                this.$emit('nextClick');
            },
            prev() {
                this.$emit('prevClick')
            },
            handleRowChange() {
                // console.log(this.rowsPerPage);
                this.$emit('rowChanged', this.rowsPerPage)
            },
            getTotalCount() {
                this.$emit('getCount')
            }
        },
        mounted() {
            if (this.perPage)
                this.rowsPerPage = this.perPage;
            // console.log(this.showingOf);
        }
    }
</script>
<style>

    .pulse-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .pulse-bubble {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: #1976d2;
    }

    .pulse-bubble-1 {
        animation: pulse .4s ease 0s infinite alternate;
    }

    .pulse-bubble-2 {
        animation: pulse .4s ease .2s infinite alternate;
    }

    .pulse-bubble-3 {
        animation: pulse .4s ease .4s infinite alternate;
    }

    @keyframes pulse {
        from {
            opacity: 1;
            transform: scale(1);
        }
        to {
            opacity: .25;
            transform: scale(.75);
        }
    }
</style>
